import Menu, { MenuProps } from "@mui/material/Menu";
import { ReactNode } from "react";

export interface AppMenuProps
  extends Omit<MenuProps, "anchorEl" | "children" | "onClose" | "open"> {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
}

/**
 * The console's popup menu. Paper (radius 14, menu elevation, divider border) and item
 * (radius 8) styling comes from the `MuiMenu`/`MuiMenuItem` theme overrides.
 */
export const AppMenu = ({
  children,
  open,
  onClose,
  anchorEl,
  ...rest
}: AppMenuProps) => (
  <Menu
    anchorEl={anchorEl}
    open={open && anchorEl !== null}
    onClose={onClose}
    {...rest}
  >
    {children}
  </Menu>
);

export default AppMenu;
